import request from '@/router/axios';
let urlPrefix = '/api/shenbao/shenbaoinfoapi'


/**
 * 获取列表
 * @param {页数} page
 * @param {每页条数} limit
 * @param {查询参数} params
 */
export const getList = (page, limit, params) => {
    return request(`${urlPrefix}/query`,{
        params: {
            ...params,
            page,
            limit,
        }
    })
}

/**
 * 批量删除
 * @param {Array} ids
 */
export const remove = ids => {
    return request(`${urlPrefix}/deleteBatch`,{
        data: ids,
        method:'delete'
    })
}

/**
 * 获取对象
 * @param {ID} id
 */
export const getEntity = id => {
    return request(`${urlPrefix}/${id}`)

}

/**
 * 添加操作
 * @param {对象} row
 */
export const add = data => {
    return request(`${urlPrefix}`,{
        data:data,
        method:'post'
    })
}

// 
/**
 * 
 * @param {*} row  /shenbaoinfopage/info/{id}   获取申报项目页面配置详情
 */
export const getApiInfoEntity = id => {
    return request(`${urlPrefix}/info/${id}`)
}

/**
 * 编辑操作
 * @param {对象} row
 */
export const update = data => {
    return request(`${urlPrefix}`,{
            method: 'put',
            data: data
        }
    )
}